const INPUTS_TYPES = {
  input: window.HTMLInputElement,
  textarea: window.HTMLTextAreaElement,
  select: window.HTMLSelectElement,
};

/**
 * Fire change event for input type
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js
 * @param node ref of node
 * @param type type of node
 * @param value value to set
 */
export function fireInputChange(node: Element | null, type: keyof typeof INPUTS_TYPES, value: any) {
  if (!node || typeof window === 'undefined') {
    return;
  }

  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    INPUTS_TYPES[type].prototype,
    'value',
  )?.set;

  if (nativeInputValueSetter) {
    nativeInputValueSetter.call(node, value);
  }

  const ev2 = new Event('input', { bubbles: true });
  node.dispatchEvent(ev2);
}
